import React, {useEffect, useState} from 'react';
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {useParams} from "react-router-dom";
import {ApiService} from "../../../../service/ApiService";
import {memberResultType} from "../../../../types/Api/MemberResultType";
import {memberHydrator} from "../../../../models/hydrator/memberHydrator";
import {member} from "../../../../models/member";
import {Loader} from "../../../../components/admin/Loader";
import {MemberForm} from "../../../../components/admin/member/MemberForm";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [member, setMember] = useState(undefined as undefined | member);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/member/${uuid}`) as Promise<memberResultType>;

      setLoading(true);

      result
        .then((r) => {
          setMember(memberHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader />
      )}

      {!loading && (member || !uuid) && (
        <>
          <BoxTitle title={uuid ? 'Modifier un membre' : 'Ajouter un membre'}/>
          <MemberForm member={member} />
        </>
      )}
    </>
  );
}
